import client from '../../utils/api'
import { createSlice } from '@reduxjs/toolkit'
import { createApiAction } from '../../utils/redux-tool'

const name = 'evaluationDetails'
const initialState = {
  list: null,
  loading: false,
  error: null,
  reportList: null,
  reportLoading: false,
  reportError: null,
}


export const search = createApiAction('evaluationDetails/search', client.search('/api/evaluation/admin/self'))
export const save = createApiAction('evaluationDetails/save', client.update('/api/evaluation/admin/self'))
export const getReport = createApiAction('evaluationDetails/searchReport', client.search('/api/evaluation/admin/self/report'))


const sessionSlice = createSlice({
  name,
  initialState,
  reducers: {
    clearDetails: state => {
      state.list = null
    },
  },
  extraReducers(builder) {
    builder
      .addCase(search.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(search.fulfilled, (state, action) => {
        state.list = action.payload;
        state.loading = false;
      })
      .addCase(getReport.pending, (state) => {
        state.reportLoading = true;
        state.reportError = null;
      })
      .addCase(getReport.fulfilled, (state, action) => {
        state.reportList = action.payload;
        state.reportLoading = false;
      })
      .addCase(save.fulfilled, (state, action) => {
        state.list = action.payload
      }
      )
  },
})

export const { clearDetails } = sessionSlice.actions
export default sessionSlice.reducer
